import { apiClient } from "@/lib/api/client";
import type { paths } from "@/lib/api/schema";

export type AdminYardListItem =
  paths["/api/admin/yards"]["get"]["responses"][200]["content"]["application/json"]["data"]["yards"][number];

export type FetchAllYardsResult =
  | { yards: AdminYardListItem[]; status: number }
  | { yards: null; status: number };

/** Largest page the admin yards list endpoint accepts. */
const PAGE_SIZE = 100;

/**
 * Loads every yard from the paginated admin list. A single unparameterized
 * call only returns the first page (25 yards by name), which silently dropped
 * yards from pickers and screens once the platform grew past it.
 */
export async function fetchAllYards(): Promise<FetchAllYardsResult> {
  const yards: AdminYardListItem[] = [];
  let page = 1;

  for (;;) {
    const { data, response } = await apiClient.GET("/api/admin/yards", {
      params: { query: { page, pageSize: PAGE_SIZE } },
    });
    if (!data) {
      return { yards: null, status: response.status };
    }
    yards.push(...data.data.yards);
    if (data.data.yards.length < PAGE_SIZE || yards.length >= data.data.total) {
      return { yards, status: response.status };
    }
    page += 1;
  }
}
